import { Box, Grid, Typography } from '@mui/material';
import { City, Country } from 'country-state-city';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';


const CountrySelect = ({ label, country, city, onPaisChange, onCityChange, disabled = false }) => {
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);

  useEffect(() => {
    const allCountries = Country.getAllCountries().map(country => ({
      value: country.isoCode,
      label: country.name,
    }));
    setCountries(allCountries);
  }, []);

  useEffect(() => {
    if (country) {
      const foundCountry = countries.find(c => c.value === country) || null;
      setSelectedCountry(foundCountry);
    }
  }, [country, countries]);

  useEffect(() => {
    if (selectedCountry) {
      const cityList = City.getCitiesOfCountry(selectedCountry.value).map(city => ({
        value: city.name,
        label: city.name,
      }));
      setCities(cityList);
    } else {
      setCities([]);
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (city) {
      const foundCity = cities.find(c => c.value === city) || null;
      setSelectedCity(foundCity);
    }
  }, [city, cities]);

  const handleCountryChange = (selectedOption) => {
    if (selectedOption) {
      onPaisChange(selectedOption.value);
      setSelectedCountry(selectedOption);
    } else {
      onPaisChange('');
      setSelectedCountry(null);
    }
  };

  const handleCityChange = (selectedOption) => {
    if (selectedOption) {
      onCityChange(selectedOption.value);
      setSelectedCity(selectedOption);
    } else {
      onCityChange('');
      setSelectedCity(null);
    }
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography>{label}:</Typography>
          <Select            
            options={countries}
            value={selectedCountry}
            onChange={handleCountryChange}
            isDisabled={true}
            placeholder="Selecciona un país"
          />
        </Grid>
        <Grid item xs={12} style={{ marginTop: 20 }}>
        <Typography>Ciudad:</Typography>
          <Select
               options={cities}
               value={selectedCity}
               onChange={handleCityChange}
               isDisabled={!selectedCountry || disabled}
               placeholder="Selecciona una ciudad"
             />
           </Grid>
         </Grid>
       </Box>
     );
   };

   CountrySelect.propTypes = {
     label: PropTypes.func.isRequired,
     country: PropTypes.func.isRequired,
     city: PropTypes.func.isRequired,
     onPaisChange: PropTypes.func.isRequired,
     onCityChange: PropTypes.func.isRequired,
     disabled: PropTypes.bool,
   };

   export default CountrySelect;
